
import { computed, defineComponent } from "@vue/runtime-core";

export default defineComponent({
  props: {
    iconClasses: String,
    size: {
      type: String,
      default: () => "lg",
    },
    color: {
      type: String,
      default: () => "gray",
      validator: (value: string) => {
        // The value must match one of these strings
        return (
          [
            "primary",
            "secondary",
            "accent",
            "gray",
            "blue",
            "green",
            "red",
            "white",
            "yellow",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  computed: {
    sizeClasses() {
      if (this.size === "lg") {
        return "w-8 h-8";
      }

      if (this.size === "sm") {
        return "w-6 h-6";
      }
    },
  },
  setup(props) {
    const classNames = computed(() => {
      return `pill pill--${props.color}`;
    });

    const iconClassNames = computed(() => {
      return `pill__icon pill__icon--${props.color} ${props.iconClasses}`;
    });

    return {
      classNames,
      iconClassNames,
    };
  },
});
